/** @format */

import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { DCSG_CONSTANTS } from '@shared/data-access/constants';

@Component({
	selector: 'common-nike-connect-overlay',
	templateUrl: './nike-connect-overlay.component.html',
	styleUrl: './nike-connect-overlay.component.scss',
	standalone: false
})
export class NikeConnectOverlayComponent implements OnInit {
	constructor(@Inject(PLATFORM_ID) private platformId) {}

	public showNikeOverlay = false;
	public nikeLock = `${DCSG_CONSTANTS.baseImagePath}nikeLock.svg`;
	public nikeDSGLogo = `${DCSG_CONSTANTS.baseImagePath}nikeDSGColor.svg`;

	public ngOnInit() {
		/* istanbul ignore else */
		if (isPlatformBrowser(this.platformId)) {
			window.document.addEventListener('nikeConnectSuccess', () => {
				this.showNikeOverlay = true;

				setTimeout(() => {
					this.showNikeOverlay = false;
				}, 1000);
			});
		}
	}
}
